"use client";

import { useCart } from "@/context/CartContext";

export function FloatingCartButton() {
  const { totalItems, openSidebar } = useCart();

  if (totalItems === 0) return null;

  return (
    <button
      type="button"
      onClick={openSidebar}
      className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#111] text-white shadow-lg shadow-black/20 transition-all duration-300 hover:scale-105 hover:bg-[#333] hover:shadow-xl animate-in fade-in zoom-in dark:bg-white dark:text-[#111] dark:shadow-black/30 dark:hover:bg-gray-200"
      aria-label={`Open cart (${totalItems} items)`}
    >
      {/* Cart icon */}
      <svg
        className="h-5.5 w-5.5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth="1.8"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
        />
      </svg>

      {/* Badge */}
      <span className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1.5 text-[10px] font-bold text-white">
        {totalItems > 99 ? "99+" : totalItems}
      </span>
    </button>
  );
}
